<template>
  <div class="payment">
    <div v-if="paymentType == 'card'" class="card">
      <div class="row">
        <div class="item" style="width: 70%">
          <input-text-type-1
            inputText="CARD NUMBER"
            placeholder="CARD NUMBER"
            v-on:model="v => (paymentForm.cardNumber = v)"
          ></input-text-type-1>
        </div>
        <div class="item" style="width: 20%">
          <input-text-type-1
            inputText="PROMO CODE"
            placeholder="PROMO CODE"
            v-on:model="v => (paymentForm.promoCode = v)"
          ></input-text-type-1>
        </div>
      </div>
      <div class="row" style="width: 70%">
        <div class="item" style="width: 45%">
          <input-text-type-1
            inputText="EXPIRES ON"
            placeholder="MM/YY"
            v-on:model="v => (paymentForm.promoCode = v)"
          ></input-text-type-1>
        </div>
        <div class="item" style="width: 45%">
          <input-text-type-1
            inputText="SECURITY CODE"
            placeholder="SECURITY CODE"
            v-on:model="v => (paymentForm.promoCode = v)"
          ></input-text-type-1>
        </div>
      </div>
      <div class="row" style="width: 70%">
        <div class="item" style="width: 45%">
          <input-text-type-1
            inputText="ADDRESS"
            placeholder="ADDRESS"
            v-on:model="v => (paymentForm.promoCode = v)"
          ></input-text-type-1>
        </div>
        <div class="item" style="width: 45%">
          <input-text-type-1
            inputText="COUNTRY"
            placeholder="COUNTRY"
            v-on:model="v => (paymentForm.promoCode = v)"
          ></input-text-type-1>
        </div>
      </div>
      <div class="row" style="width: 70%">
        <div class="item" style="width: 45%">
          <input-text-type-1
            inputText="CITY"
            placeholder="CITY"
            v-on:model="v => (paymentForm.city = v)"
          ></input-text-type-1>
        </div>
        <div class="item" style="width: 45%">
          <input-text-type-1
            inputText="POSTAL CODE"
            placeholder="POSTAL CODE"
            v-on:model="v => (paymentForm.postalCode = v)"
          ></input-text-type-1>
        </div>
      </div>
      <div class="row" style="margin-top: 50px">
        <span
          >We wii not charge you until photographer accept your request</span
        >
      </div>
    </div>
    <div v-else class="paypal">paypal</div>
    <vue-stripe-checkout
      v-if="requestBookingInfo"
      ref="checkoutRef"
      :image="image"
      :name="userInfo.firstName + userInfo.name"
      :description="requestBookingInfo.location.address.detail"
      :currency="serviceDetail.currencyUnit"
      :amount="parseInt(serviceDetail.price, 10)"
      :allow-remember-me="false"
      @done="done"
      @opened="opened"
      @closed="closed"
      @canceled="canceled"
    ></vue-stripe-checkout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InputTextType1 from '../common/form-elemnets/InputTextType1'
import * as firebaseConnection from 'firebase'

export default {
  components: {
    InputTextType1
  },
  name: 'payment',
  data() {
    return {
      paymentType: 'card',
      paymentForm: {
        cardNumber: '',
        promoCode: '',
        postalCode: '',
        city: '',
        address: '',
        expires: '',
        securityCode: ''
      },
      image: 'https://i.imgur.com/HhqxVCW.jpg',
      name: 'Shut up and take my money!',
      description: 'Cats are the best dog!',
      currency: '',
      amount: 99999
    }
  },
  computed: {
    ...mapGetters([
      'serviceProfile',
      'serviceDetail',
      'modalRequestComponentName',
      'requestBookingInfo',
      'userInfo'
    ])
  },
  mounted() {
    firebaseConnection
      .storage()
      .ref(this.serviceProfile.profileImage.url)
      .getDownloadURL()
      .then(url => {
        this.image = url
      })
  },
  methods: {
    async checkout() {
      // token - is the token object
      // args - is an object containing the billing and shipping address if enabled
      // const { token, args } = await this.$refs.checkoutRef.open()
      await this.$refs.checkoutRef.open()
    },
    done({ token, args }) {
      // token - is the token object
      // args - is an object containing the billing and shipping address if enabled
      // do stuff...
      console.log(token, args)
    },
    opened() {
      // do stuff
    },
    closed() {
      // do stuff
    },
    canceled() {
      // do stuff
    }
  }
}
</script>

<style lang="scss" scoped>
.payment {
  .row {
    position: relative;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;

    .item {
      /*border: 1px solid red;*/
    }
  }

  .card {
    padding: 30px;
    width: 750px;
    height: 430px;
    border: 1px solid lightgray;
    display: block;
  }
}
</style>
